import React, { useCallback, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';

import useAppNavigation from '~/hooks/useAppNavigation';

import { type IAppName } from '~/services/AwsJobsService';

import AwsJobsPageContainer from './PageContainer';
import { DERBYSOFT_TYPE, PUBLIC_OFFERS_TYPE, RATEDOCK_TYPE, RENTALSUNITED_TYPE } from './constants';

function AwsJobsPage() {
  const { replace } = useAppNavigation();
  const location = useLocation();

  const getInitialTab = useCallback(() => {
    const hash = location.hash.replace('#', '');
    return (hash || PUBLIC_OFFERS_TYPE) as IAppName;
  }, [location.hash]);

  const [selectedTab, setSelectedTab] = useState<IAppName>(getInitialTab);

  const handleTabChange = useCallback(
    (_, value) => {
      setSelectedTab(value);

      replace({
        pathname: location.pathname,
        search: value !== PUBLIC_OFFERS_TYPE ? location.search : '',
        hash: value,
      });
    },
    [replace, location.pathname, location.search],
  );

  return (
    <Container>
      <Helmet>
        <title>AWS Jobs</title>
      </Helmet>
      <PageHeader title="AWS Jobs" />
      <SectionNavigationLayout
        navigation={
          <SectionNavigation
            label="AWS Jobs sections"
            currentTab={selectedTab}
            groups={[
              {
                items: [
                  {
                    id: PUBLIC_OFFERS_TYPE,
                    label: 'Public Offers',

                    href: `${location.pathname}#${PUBLIC_OFFERS_TYPE}`,
                  },
                  {
                    id: DERBYSOFT_TYPE,
                    label: 'Derbysoft',

                    href: `${location.pathname}#${DERBYSOFT_TYPE}`,
                  },
                  {
                    id: RATEDOCK_TYPE,
                    label: 'Ratedock',

                    href: `${location.pathname}#${RATEDOCK_TYPE}`,
                  },
                  {
                    id: RENTALSUNITED_TYPE,
                    label: 'Rentalsunited',

                    href: `${location.pathname}#${RENTALSUNITED_TYPE}`,
                  },
                ],
              },
            ]}
            onSelect={(event, id) => {
              event.preventDefault();
              handleTabChange(event, id);
            }}
          />
        }
      >
        <AwsJobsPageContainer selectedTab={selectedTab} />
      </SectionNavigationLayout>
    </Container>
  );
}

export default AwsJobsPage;
